import { Modal } from '../../components/ui';
import { LeadDetailContent } from './LeadDetailContent';

/**
 * The lead board's quick-look popup - clicking a card opens this instead
 * of navigating to `/leads/:id`, so the board stays mounted underneath.
 * `/leads/:id` itself (`LeadDetailPage`) still works as a real page for
 * direct links (notifications, task/follow-up "go to lead" links, etc.) -
 * this modal is purely an alternate entry point from the board.
 */
export function LeadDetailModal({ id, onClose }: { id: string; onClose: () => void }) {
  return (
    <Modal title="Lead details" onClose={onClose} wide>
      <LeadDetailContent id={id} onClose={onClose} />
    </Modal>
  );
}
